import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

    connect() {
        // console.log("DrivingSchoolPaymentTransferQuickLookController connected1!ASSSS");
    }

    async showQuickLook(event) {
        event.preventDefault();

        // get instructor-id
        const instructorId = event.target.dataset.instructorId;
        const paymentId = event.target.dataset.paymentLinkId;

        let url = `/schools/team/${instructorId}/payments/${paymentId}/transfer/quick-look`

        const response = await this.performFetch(url, "GET");

        if (response.ok) {
            const quickViewElement = document.querySelector("#transfer-instructor-payment-quick-look");
            if (quickViewElement) {
                quickViewElement.classList.remove("u-hidden");

                const responseBody = await response.text();
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(responseBody, "text/html");
                const template = xmlDoc.querySelector("template");
                const turboFrameElement = quickViewElement;

                if (turboFrameElement && template) {
                    turboFrameElement.innerHTML = "";
                    turboFrameElement.appendChild(template.content.cloneNode(true));
                }
            } else {
                console.error("Quick view element not found");
            }
        }
    }

    async performFetch(url, method, body = null) {
        const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
        const headers = {
            "X-CSRF-Token": csrfToken,
            "Accept": "text/vnd.turbo-stream.html"
        };

        const options = {
            method: method,
            headers: headers
        };

        if (body) {
            options.body = body;
        }

        try {
            return await fetch(url, options);
        } catch (error) {
            console.error("Error performing fetch: ", error);
            return { error: "Network error, please check your connection and try again." };
        }
    }

    closeQuickLook(event) {
        event.preventDefault();

        const quickViewElement = document.querySelector("#transfer-instructor-payment-quick-look");
        quickViewElement.classList.add("u-hidden");
    }

    async filterInstructorSelected(event) {
        let selectedInstructorId = event.detail.id

        // Show loading state
        this.showLoadingState();

        // Refresh the payment and lesson details with the new instructor filter
        await this.getPaymentAndLessonDetails(selectedInstructorId);
    }

    async getPaymentAndLessonDetails(selectedInstructorId) {
        const originalInstructorId = this.element.dataset.originalInstructorId;
        const paymentLinkId = this.element.dataset.paymentLinkId;

        // Store selected instructor for later use
        this.element.dataset.selectedInstructorId = selectedInstructorId;

        const url = `/schools/team/${originalInstructorId}/payments/${paymentLinkId}/transfer/quick-look/lessons?selected_instructor_id=${selectedInstructorId}`;

        try {
            const response = await this.performFetch(url, "GET");

            // Always hide loading state regardless of response
            this.hideLoadingState();

            if (response.ok) {
                const responseBody = await response.text();
                console.log("=== FULL RESPONSE BODY ===");
                console.log(responseBody);

                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(responseBody, "text/html");

                // Debug the parsed document
                console.log("=== PARSED XML DOC ===");
                console.log(xmlDoc);

                const turboStreamTemplate = xmlDoc.querySelector("template");
                console.log("=== TURBO STREAM TEMPLATE ===");
                console.log(turboStreamTemplate);

                if (turboStreamTemplate) {
                    console.log("=== TEMPLATE CONTENT ===");
                    console.log(turboStreamTemplate.content);
                    console.log("=== TEMPLATE INNER HTML ===");
                    console.log(turboStreamTemplate.innerHTML);
                }

                // Update the lessons section - extract from Turbo Stream template
                const lessonsSection = document.querySelector("#lessons-selection-section");

                if (lessonsSection && turboStreamTemplate) {
                    lessonsSection.innerHTML = turboStreamTemplate.innerHTML;
                    lessonsSection.classList.remove("u-hidden");
                }

                // Check if transfer is possible by looking inside the template content
                const cannotTransferElement = turboStreamTemplate ? turboStreamTemplate.content.querySelector("#cannot-transfer-message") : null;
                const canTransfer = !cannotTransferElement;

                console.log("=== CANNOT TRANSFER ELEMENT ===");
                console.log("Cannot transfer element found:", cannotTransferElement);
                console.log("Can transfer:", canTransfer);

                // Also try looking in the innerHTML directly
                const htmlContainsCannotTransfer = turboStreamTemplate && turboStreamTemplate.innerHTML.includes('id="cannot-transfer-message"');
                console.log("HTML contains cannot-transfer-message:", htmlContainsCannotTransfer);

                const saveSection = document.querySelector("#save-section");
                console.log("=== SAVE SECTION ===");
                console.log("Save section found:", saveSection);

                if (saveSection && canTransfer) {
                    console.log("SHOWING save section");
                    saveSection.classList.remove("u-hidden");
                } else if (saveSection) {
                    console.log("HIDING save section");
                    saveSection.classList.add("u-hidden");
                }
            } else {
                console.error("Error fetching lesson details");
                this.showErrorState("Error loading lesson details. Please try again.");
            }
        } catch (error) {
            // Always hide loading state on error
            this.hideLoadingState();
            console.error("Network error:", error);
            this.showErrorState("Network error. Please check your connection and try again.");
        }
    }

    showLoadingState() {
        const loadingSection = document.querySelector("#loading-section");
        const lessonsSection = document.querySelector("#lessons-selection-section");
        const saveSection = document.querySelector("#save-section");

        if (loadingSection) loadingSection.classList.remove("u-hidden");
        if (lessonsSection) lessonsSection.classList.add("u-hidden");
        if (saveSection) saveSection.classList.add("u-hidden");
    }

    hideLoadingState() {
        const loadingSection = document.querySelector("#loading-section");
        if (loadingSection) loadingSection.classList.add("u-hidden");
    }

    showErrorState(message) {
        const lessonsSection = document.querySelector("#lessons-selection-section");
        if (lessonsSection) {
            lessonsSection.innerHTML = `
                <div class="Alert Alert--error mb2">
                    <p>${message}</p>
                </div>
            `;
            lessonsSection.classList.remove("u-hidden");
        }
    }

    lessonSelected(event) {
        const selectedLessonId = event.detail.id;
        console.log('Selected Lesson ID: ', selectedLessonId);

        // Store the selected lesson for later use
        this.element.dataset.selectedLessonId = selectedLessonId;
    }

    async saveTransfer(event) {
        event.preventDefault();

        const selectedInstructorId = this.element.dataset.selectedInstructorId;
        const selectedLessonId = this.element.dataset.selectedLessonId;
        const originalInstructorId = this.element.dataset.originalInstructorId;
        const paymentLinkId = this.element.dataset.paymentLinkId;

        console.log('Saving transfer with:', {
            selectedInstructorId,
            selectedLessonId,
            originalInstructorId,
            paymentLinkId
        });

        // Disable the save button and show loading state
        const saveButton = event.target;
        const originalText = saveButton.textContent;
        saveButton.disabled = true;
        saveButton.textContent = 'Saving...';

        try {
            const url = `/schools/team/${originalInstructorId}/payments/${paymentLinkId}/transfer/quick-look/save`;

            // Create form data
            const formData = new FormData();
            formData.append('selected_instructor_id', selectedInstructorId);
            if (selectedLessonId) {
                formData.append('selected_lesson_id', selectedLessonId);
            }

            const response = await this.performFetch(url, "POST", formData);

            if (response.ok) {
                // Success - close the modal and show success message
                alert('Transfer saved successfully!');
                this.closeQuickLook(event);

                // Optionally refresh the page to show updated data
                // window.location.reload();
            } else {
                console.error("Error saving transfer");
                alert('Error saving transfer. Please try again.');
            }
        } catch (error) {
            console.error("Network error during save:", error);
            alert('Network error. Please check your connection and try again.');
        } finally {
            // Re-enable the save button
            saveButton.disabled = false;
            saveButton.textContent = originalText;
        }
    }
}